import { App, AppManager, Input, Mutation, Model } from 'core/index';
import { observable, action } from 'mobx';
import { WizardStore } from 'libs/wizards/app';
import { conf } from 'apps/home/contact/config.yaml';
import { clientStore } from 'apps/client/app';
import Alert from 'react-s-alert';
import i18next from 'i18next';

class ContactModel extends Model {
  static registryName = 'ContactModel';
  @observable name = '';
  @observable email = '';
  @observable company = '';
  @observable subject = '';
  @observable message = '';
}

export class ContactApp extends App {
  static registryName = 'ContactApp';
  static Model = ContactModel;
  init() {
    this.wizard = new WizardStore(this, conf, 'contactWizard', {
      submit: this.Submit,
    });
  }

  @action onSysError = () => {
    this.wizard.activeForm.SetPosting(false);
    clientStore.SetPosting(false);
    Alert.error(
      i18next.t('Hmm... We failed to send this Form. Please try again.'),
    );
  };

  @action onUserErr = () => {
    this.wizard.activeForm.SetPosting(false);
    clientStore.SetPosting(false);
  };

  @action onSuccess = () => {
    clientStore.SetPosting(false);
    clientStore.routerStore.navigate('home');
  };

  @action Submit = () => {
    if (this.wizard.activeForm.isValid) {
      this.wizard.activeForm.SetPosting(true);
      clientStore.SetPosting(true);
      this.manager.Submit({
        onSysErr: this.onSysErr,
        onUserErr: this.onUserErr,
        onSuccess: this.onSuccess,
      });
    } else {
      this.wizard.activeForm.alert();
    }
  };
}

class ContactMutation extends Mutation {
  static conf = {
    // TODO:
    // GQL: CONTACT_MUTATION,
    // inputName: 'initiativeInput',
    // resultPath: 'initiative.initiative',
    // errorPath: 'initiative.userErrors',
  };
}

export class ContactAppManager extends AppManager {
  static registryName = 'ContactAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.contactApp = new ContactApp(this, {});
    this.contactApp.init();
    this.contactInput = new Input({
      name: () => this.contactApp.name,
      email: () => this.contactApp.email,
      company: () => this.contactApp.company,
      subject: () => this.contactApp.subject,
      message: () => this.contactApp.message,
    });
  }

  @action Submit = options => {
    this.mutations.push(ContactMutation.New(this.contactInput, options));
  };
}
